<script lang="ts">
	import { slugify } from '../../slugify/slugify'
	import type { Presets } from './datetime'
	import { type Preset, presets } from './datetime'
	import { _ } from '@repo/i18n'
	import { Action } from '@repo/ui'
	import type { DateTime } from 'luxon'

	interface Props {
		allowedPresets?: Presets[]
		from?: DateTime
		to?: DateTime
		multiple?: boolean
		onPresetSelected?: (preset: Preset) => void
	}

	let {
		allowedPresets = [],
		from = null,
		to = null,
		multiple = false,
		onPresetSelected = null,
	}: Props = $props()

	function isCurrent(preset: Preset, from: DateTime, to: DateTime) {
		if (multiple) {
			return (
				from &&
				to &&
				preset.start().toISODate() === from.toISODate() &&
				preset.end().toISODate() === to.toISODate()
			)
		} else {
			return to && preset.end().toISODate() === to.toISODate()
		}
	}
</script>

<div class="flex gap-4 overflow-x-auto p-4 {multiple ? 'xl:flex-col' : ''}">
	{#each allowedPresets as presetIndex (presetIndex)}
		<Action
			name="datepicker-preset-{slugify(presets[presetIndex].title)}"
			class="{isCurrent(presets[presetIndex], from, to)
				? 'text-primary-500 font-bold'
				: ''} whitespace-nowrap"
			label={$_(presets[presetIndex].title)}
			onclick={() => onPresetSelected(presets[presetIndex])}
		/>
	{/each}
</div>
